import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

import Typography from "@mui/material/Typography";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";

import { StyledSwitch } from "../../components/Base";
import Button from "../../components/Button";
import TableComponent from "../../components/TableComponent";
import { SignOffDateButton } from "../../features/training-sign-off-date";
import {
  getUsersInscribed,
  updateCheckingProgress,
  updateModuleStatus,
  updateStatusCertificate,
} from "../../api/training.deprecated";
import { isClassroomModuleCompleted, isTrainingCompleted } from "../../api/training";
import useUser from "../../hooks/useUser";
import useCrew from "../../hooks/useCrew";

const TrainerCheckingProgress = ({ match, history }) => {
  const { t } = useTranslation();
  const [usersInscribed, setUsersInscribed] = useState([]);
  const [refresh, setRefresh] = useState(1);
  const trainingId = match.params.trainingId;
  const classroomAttendance = +match.params.classroomAttendance;
  const classroomTest = +match.params.classroomTest;
  const evaluator = useUser();
  const crew = useCrew();

  useEffect(() => {
    (async () => {
      const usersInscribed = await getUsersInscribed(trainingId, crew.crew.id, crew.baseIds);
      setUsersInscribed(usersInscribed);
    })();
  }, [refresh, crew]);

  const onEventSwitch = async (id, field, value, userInscribed) => {
    const res = await updateCheckingProgress(id, field, value, evaluator.id);

    const classroom_status = isClassroomModuleCompleted({ classroomAttendance, classroomCheck: classroomTest }, res)
      ? 1
      : 0;
    const resAfterUpdateModule = await updateModuleStatus(id, "classroom_status", classroom_status);

    await updateStatusCertificate(
      userInscribed.user_id,
      userInscribed.Training.Course.id,
      isTrainingCompleted(userInscribed.Training, resAfterUpdateModule) ? 1 : 0,
    );

    setRefresh(refresh * -1);
  };

  return (
    <>
      <Typography variant="h4">{t("training_pages.training_checking_progress")}</Typography>
      {usersInscribed && (
        <TableComponent
          header={[
            { title: t("training_pages.user_id"), style: { width: "5%" } },
            { title: t("user") },
            { title: t("training.classroom_attendance") },
            { title: t("training.classroom_test") },
          ]}
          renderChildren={(userInscribed, index) => (
            <TableRow key={index}>
              <TableCell>{userInscribed.user_id}</TableCell>
              <TableCell>{userInscribed.fullname}</TableCell>

              <TableCell>
                {classroomAttendance == 1 && (
                  <>
                    <StyledSwitch
                      title={t("training.classroom_attendance")}
                      checked={userInscribed.classroom_attendance === 1}
                      onChange={() => {
                        const valSwitch = userInscribed.classroom_attendance === 1 ? 0 : 1;
                        onEventSwitch(userInscribed.id, "classroom_attendance", valSwitch, userInscribed);
                      }}
                    />
                    {userInscribed.classroom_attendance === 1 && (
                      <SignOffDateButton
                        trainingUserId={userInscribed.id}
                        field="classroom_attendance"
                        date={userInscribed.classroom_attendance_date}
                        onSaved={() => setRefresh(refresh * -1)}
                      />
                    )}
                  </>
                )}
              </TableCell>
              <TableCell>
                {classroomTest == 1 && (
                  <>
                    <StyledSwitch
                      title={t("training_pages.training_test")}
                      checked={userInscribed.classroom_test === 1}
                      onChange={() => {
                        const valSwitch = userInscribed.classroom_test === 1 ? 0 : 1;
                        onEventSwitch(userInscribed.id, "classroom_test", valSwitch, userInscribed);
                      }}
                    />
                    {userInscribed.classroom_test === 1 && (
                      <SignOffDateButton
                        trainingUserId={userInscribed.id}
                        field="classroom_test"
                        date={userInscribed.classroom_test_date}
                        onSaved={() => setRefresh(refresh * -1)}
                      />
                    )}
                  </>
                )}
              </TableCell>
            </TableRow>
          )}
          search={["user_id", "fullname"]}
          pagination
          items={usersInscribed}
        />
      )}
      <Button title={t("back")} onClick={() => history.goBack()}>
        {t("back")}
      </Button>
    </>
  );
};

export default TrainerCheckingProgress;
